import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState} from '../store';
import {Observable} from 'rxjs';
import {getHomePageContent} from '../store/content.actions';
import {createContentResolver} from './create-content-resolver';
import {LoadingService} from '../shared/services/loading.service';


@Injectable({
  providedIn: 'root'
})
export class HomePageContentResolver  {
  private store = inject<Store<AppState>>(Store);
  private loading = inject(LoadingService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);



  constructor() {

  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

    const loadContent$ = createContentResolver(this.store, "homePage", getHomePageContent);

    return this.loading.showLoaderUntilCompleted(loadContent$);
  }


}
